import { normalizeTabSlug, resolveStudentTabRouteSlug } from "./slugs";

/** @typedef {{ contenidoTabs?: string[], testBlocks?: string[] }} StudentTabRouteHints */

const REGISTERED_STUDENT_TAB_ROUTES = new Set([
  "campus",
  "test-temas",
  "test-examen",
  "resumenes",
  "rendimiento",
  "informacion",
  "mensajeria-interna",
]);

/**
 * @param {string} tabLabel
 * @param {StudentTabRouteHints} [hints]
 * @returns {{ routeSlug: string, pestana: string }}
 */
export function resolveStudentTabDestination(tabLabel) {
  const label = typeof tabLabel === "string" ? tabLabel.trim() : "";
  if (label.length === 0) {
    return { routeSlug: "campus", pestana: "" };
  }

  const slug = normalizeTabSlug(label);
  const mappedRoute = resolveStudentTabRouteSlug(label);

  if (mappedRoute === "test-temas") {
    return { routeSlug: "campus", pestana: label };
  }

  if (mappedRoute !== slug) {
    return { routeSlug: mappedRoute, pestana: label };
  }

  if (REGISTERED_STUDENT_TAB_ROUTES.has(mappedRoute)) {
    return { routeSlug: mappedRoute, pestana: label };
  }

  return { routeSlug: "campus", pestana: label };
}

/**
 * @param {string} tabLabel
 * @returns {string}
 */
export function buildStudentTabPath(tabLabel) {
  const { routeSlug, pestana } = resolveStudentTabDestination(tabLabel);
  const basePath = `/usuario/${routeSlug}`;
  if (pestana.length > 0) {
    return `${basePath}?pestana=${encodeURIComponent(pestana)}`;
  }
  return basePath;
}
